import { render } from "./DynamicHtmlDiv.vue?vue&type=template&id=61ff9002&ts=true"
import script from "./DynamicHtmlDiv.vue?vue&type=script&lang=ts"
export * from "./DynamicHtmlDiv.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicHtmlDiv.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61ff9002"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61ff9002', __exports__)) {
    api.reload('61ff9002', __exports__)
  }
  
  module.hot.accept("./DynamicHtmlDiv.vue?vue&type=template&id=61ff9002&ts=true", () => {
    api.rerender('61ff9002', render)
  })

}


export default __exports__